import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import pt from "./locales/pt.json";
import en from "./locales/en.json";
import es from "./locales/es.json";

export const SUPPORTED_LANGS = ["pt", "en", "es"];

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            pt: { translation: pt },
            en: { translation: en },
            es: { translation: es },
        },
        fallbackLng: "pt",
        supportedLngs: SUPPORTED_LANGS,
        nonExplicitSupportedLngs: true,
        interpolation: { escapeValue: false },
        detection: {
            order: ["localStorage", "navigator", "htmlTag"],
            caches: ["localStorage"],
            lookupLocalStorage: "synara_lang",
        },
        returnObjects: true,
    });

// Keep <html lang> in sync for SEO
const applyHtmlLang = (lng) => {
    if (typeof document !== "undefined") {
        document.documentElement.lang = (lng || "pt").split("-")[0];
    }
};
applyHtmlLang(i18n.language);
i18n.on("languageChanged", applyHtmlLang);

export default i18n;
